import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { DestinosService } from 'src/app/services/destinos/destinos.service';
import { EquipoTrabajoService } from 'src/app/services/equipo-trabajo/equipo-trabajo.service';
import { URL_IMGS } from 'src/environments/environment';

@Component({
  selector: 'app-promociondetalle',
  templateUrl: './promociondetalle.component.html',
  styleUrls: ['./promociondetalle.component.css'],
})
export class PromociondetalleComponent implements OnInit {
  public url = `${URL_IMGS}recomendaciones`;
  public dangerousVideoUrl = null;
  public map_url = null;
  public promocion;
  public imagenes_carrusel = [];
  public teams = []
  constructor(
    private sanitizer: DomSanitizer,
    private _promocionesService: DestinosService,
    private rotuter: Router,
    private route: ActivatedRoute,
    private _equipoTrabajoService: EquipoTrabajoService,
  ) { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this._promocionesService
      .getById(this.route.snapshot.paramMap.get('id'))
      .subscribe((res: any) => {
        if (!res.err && !!res.result) {
          this.promocion = res.result;
          console.log('res.result', res.result);
          let img = this.promocion.imagen;
          if (!`${this.promocion.imagen}`.includes(`amazonaws`)) {
            img = `${this.url}/${this.promocion.id}/${this.promocion.imagen}`;
          }
          this.imagenes_carrusel.push({
            img: img,
          });
          if (!!this.promocion.imagenes_secundarias) {
            let imagenes = `${this.promocion.imagenes_secundarias}`.split(',');
            imagenes.forEach((item) => {
              let img = item;
              if (!`${item}`.includes(`amazonaws`)) {
                img = `${this.url}/${this.promocion.id}/${item}`;
              }
              this.imagenes_carrusel.push({
                img: img,
              });
            });
          }
          if (!!res.result.map_link) {
            this.dangerousVideoUrl = res.result.map_link;
            this.map_url = this.sanitizer.bypassSecurityTrustResourceUrl(
              this.dangerousVideoUrl
            );
          }
        }
      });
    this._equipoTrabajoService.random().subscribe((res: any) => {
      res.lista.forEach((item) => {


        this.teams.push({
          img: null,
          name: item.nombre,
          position: item.puesto,
          facebook: item.facebook,
          whatsapp: item.whatsapp,
        });
      });
    });
  }
  getName(name: string) {
    return name.replace(' ', '%20').replace('ó', '%C3%B3');
  }
  descriptionToArray(descripcion: string) {
    return !!descripcion ? descripcion.split('\n') : '';
  }
}
